import { getConfigBySite } from '../../../config/sites'
import ga from '../../utils/ga'
import { Consent } from '../../utils/consent'
import { getCookie, setCookie } from '../../utils/cookieHelper'

/**
 * check if a site has only one avaiable layout
 * @param {String} siteName
 */
const hasOnlyOneLayout = siteName => {
  const itemViewsConfig = getConfigBySite(siteName, 'ui.item_list_views') || []
  return itemViewsConfig.length === 1
}

/**
 * read the default view type from config
 * @param  {String} currentSite
 * @return {String} the final view type we use
 */
export const getDefaultViewTypeBySite = currentSite =>
  getConfigBySite(currentSite, 'item_results_layout')

export const initClientUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    const {
      common: { currentSite }
    } = getState()
    const defaultSiteViewType = getDefaultViewTypeBySite(currentSite)

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setUserSearchResultsViewType(defaultSiteViewType))
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, save view type to cookie
      dispatch(setUserSearchResultsViewType(location.query.view))
    } else {
      let view = getCookie({
        itemKey: 'search-view-mode-preference',
        consentType: Consent.preferences,
        defaultValue: defaultSiteViewType
      })

      dispatch(setUserSearchResultsViewTypeWithoutCookie(view))
    }
  }
}

export const initServerUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    const currentSite = getState().common.currentSite
    const defaultSiteViewType = getDefaultViewTypeBySite(currentSite)

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType))
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, set view type to cookie
      dispatch(setServerUserSearchResultsViewType(location.query.view))
    } else {
      // otherwise read from the default config
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType))
    }
  }
}

export const setUserSearchResultsViewType = nextView => {
  setCookie({
    itemKey: 'search-view-mode-preference',
    itemValue: nextView,
    consentType: Consent.preferences
  })
  ga('send', 'event', 'product list', 'display', nextView, {
    nonInteraction: true
  })
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setUserSearchResultsViewTypeWithoutCookie = nextView => {
  ga('send', 'event', 'product list', 'display', nextView, {
    nonInteraction: true
  })
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setServerUserSearchResultsViewType = nextView => {
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setUserVideoPlayerStatus = type => {
  return {
    type: 'setUserVideoPlayerStatus',
    payload: { type }
  }
}

export const setUserVideoAutoPlayStatus = status => {
  return {
    type: 'setUserVideoAutoPlayStatus',
    payload: status
  }
}

export const setUserAudioVolumeLevel = level => {
  return {
    type: 'setUserAudioVolumeLevel',
    payload: { level }
  }
}

export const setUserAudioMuteStatus = status => {
  return {
    type: 'setUserAudioMuteStatus',
    payload: status
  }
}
